import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { isArrayLike } from '../utils/isArrayLike';

export class PropertyQuery extends BaseQuery {
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { code, key, index } = this.options;
		const entity = this.getEntity(executionOptions);
		if (entity && entity.properties_pub && entity.properties_pub[code]) {
			const property = entity.properties_pub[code][key || 'value'];
			if (typeof index === 'number' && isArrayLike(property) && property[index]) {
				return property[index];
			}
			return property;
		}
		return undefined;
	}
}